module.exports = __webpack_public_path__ + "img/ws1.7c6078a5.jpg";